import { useEffect, useState } from "react";
import he from "he";
import { getAllSelectItems } from "./useProductSelectItems";

const formatPostForSelect = (item) => ({
  label: he.decode(item.title.rendered || item.title),
  value: item.id,
});

const DEFAULT_OPTION = {
  label: "---",
  value: null,
};

export const usePostSelectorItems = (
  selectedCategoryId,
  postType,
  searchKeyword = ""
) => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  /**
   * Get all posts
   */
  useEffect(() => {
    if (postType === "posts") {
      setIsLoading(true);
      const params = new URLSearchParams({
        numberOfPost: -1,
        page: 1,
        orderby: "title",
        order: "asc",
        ...(selectedCategoryId > 0 && { currentCategory: selectedCategoryId }),
      }).toString();
      getAllSelectItems(`/${postType}/cat?${params}`, (data) => {
        setPosts(data[0].allPosts.map((p) => formatPostForSelect(p)));
        setIsLoading(false);
      });
    } else {
      // Fonction pour récupérer tous les posts
      const getAllPosts = async () => {
        setIsLoading(true);
        try {
          // Première requête pour obtenir le nombre total de pages
          const initialResponse = await fetch(
            `/wp-json/wp/v2/${postType}?per_page=100&page=1&orderby=title&order=asc`
          );

          // Récupération du nombre total de pages depuis les headers
          const totalPages = parseInt(
            initialResponse.headers.get("X-WP-TotalPages")
          );
          const firstPageData = await initialResponse.json();

          // Si il y a plus d'une page, on récupère les pages suivantes
          let allPosts = [...firstPageData];

          if (totalPages > 1) {
            // Création d'un tableau de promesses pour les pages restantes
            const remainingPages = Array.from(
              { length: totalPages - 1 },
              (_, i) => i + 2
            );
            const pagePromises = remainingPages.map((pageNum) =>
              fetch(
                `/wp-json/wp/v2/${postType}?per_page=100&page=${pageNum}&orderby=title&order=asc`
              ).then((response) => response.json())
            );

            // Attente de toutes les requêtes
            const additionalPagesData = await Promise.all(pagePromises);
            allPosts = [...allPosts, ...additionalPagesData.flat()];
          }

          // Mise à jour du state avec tous les posts formatés
          setPosts(allPosts.map((item) => formatPostForSelect(item)));
        } catch (error) {
          console.error(
            `Erreur lors de la récupération des ${postType}:`,
            error
          );
        } finally {
          setIsLoading(false);
        }
      };

      getAllPosts();
    }
  }, [selectedCategoryId, postType]);

  /**
   * Suggested posts filtered by keyword
   */
  const filteredPosts = posts.filter((p) =>
    p.label.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  return {
    posts,
    filteredPosts: [DEFAULT_OPTION, ...filteredPosts],
    isLoading,
  };
};

export default usePostSelectorItems;
